import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
